
import XHeader from 'vux/src/components/x-header/index.vue'
import querystring from 'vux/src/tools/querystring/index.js'


export default {
components: {
XHeader
},
data() {
return {
messageTitle: "消息通知",
messageData: ""
};
},
created() {
this.$vux.loading.show({
text: "请稍候..."
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadPhoneMessageInfo",
params: {
msgId: this.$route.query.id
}
})
.then(response => {
if (response.status == 200) {
if (response.data.data != null && response.data.data.length > 0) {
this.messageTitle = response.data.data[0].cmsgtitle;
this.messageData = response.data.data[0].cmsgurl;
}
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
methods: {}
};



// WEBPACK FOOTER //
// ./src/components/MessageData.vue